import jspreadsheet from "jspreadsheet";

function createDropdown(source: string[], defaultValue: string = "") {
  const dropdown = document.createElement("div");
  dropdown.className = "jdropdown-custom-container";
  const list = document.createElement("div");
  list.className = "jdropdown-c-list";

  source.forEach((item) => {
    const option = document.createElement("div");
    option.className = "jdropdown-c-item";
    if (item === defaultValue) {
      option.style.backgroundColor = "#1f93ff";
    }
    option.title = item;
    option.textContent = item;
    list.appendChild(option);
  });

  dropdown.appendChild(list);
  return dropdown;
}

// Custom dropdown editor that is appended to the document body
export const customDropdownEditor = () => {
  return {
    openEditor: (
      cell: HTMLTableCellElement,
      value: string,
      x: number,
      y: number,
      instance: jspreadsheet.worksheetInstance,
      columnData: jspreadsheet.Column
    ) => {
      const rect = cell.getBoundingClientRect();
      const dropdown = createDropdown(columnData.source as string[], value);

      // Calculate available space relative to viewport
      const viewportHeight = window.innerHeight;
      const spaceBelow = viewportHeight - rect.bottom;
      const spaceAbove = rect.top;

      // Position the dropdown relative to viewport
      dropdown.style.position = "fixed";
      dropdown.style.left = `${rect.left}px`;
      // dropdown.style.width = `${rect.width}px`;
      document.body.appendChild(dropdown);
      const dropdownRect = dropdown.getBoundingClientRect();

      if (spaceBelow >= dropdownRect.height || spaceBelow > spaceAbove) {
        // Show below
        dropdown.style.top = `${rect.bottom}px`;
      } else {
        // Show above
        dropdown.style.top = `${rect.top - dropdownRect.height}px`;
      }

      // Delay adding the document click listener
      setTimeout(() => {
        dropdown.addEventListener("click", (e) => {
          const target = e.target as HTMLElement;
          if (target.classList.contains("jdropdown-c-item")) {
            cell.textContent = target.textContent;
            setTimeout(() => {
              instance.closeEditor(cell, true);
              dropdown.remove();
            }, 20);
          }
        });

        // Close on outside click
        document.addEventListener(
          "click",
          (e) => {
            if (!dropdown.contains(e.target as Node)) {
              instance.closeEditor(cell, false);
              dropdown.remove();
            }
          },
          { once: true }
        );
      }, 400);
    },

    closeEditor: (cell: HTMLTableCellElement, save: boolean) => {
      return cell.textContent;
    },

    getValue: (cell: HTMLTableCellElement) => {
      return cell.textContent;
    },

    setValue: (cell: HTMLTableCellElement, value: string) => {
      cell.textContent = value;
    },

    createCell(cell, value, x, y, instance, options) {
      cell.textContent = value;
    },
  } as unknown as jspreadsheet.Editor;
};
